import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NexiaBasketObject } from '../../../../models/nexia-basket-object';

@Component({
  selector: 'app-bar-select',
  templateUrl: './bar-select.component.html',
  styleUrls: ['./bar-select.component.scss']
})
export class BarSelectComponent {

  @Input()
  nexiaBasketObjects: NexiaBasketObject[] = [];

  @Input()
  inBasketPage = false;

  @Input() actionEnable;

  @Input()
  allSelected = false;

  @Output()
  selectAll: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  deselectAll: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  setBasketSelectStatus: EventEmitter<any> = new EventEmitter<any>();

  public onClick(): void {
    this.setBasketSelectStatus.emit();
  }

  public onAddAllToBasket(): void {
    this.selectAll.emit();
  }

  public onRemoveAllToBasket(): void {
    this.deselectAll.emit();
  }
}
